import {
  DragItem,
  DropItem,
} from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-drop.constants';
import { ComponentInteractiveResponseSequence } from '../../../component.constants';
import {
  GetActivitiesSections_getActivitiesSections_components_ActivitiesInteractiveResponseComponent_properties,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesInteractiveResponseComponent_properties_interactiveResponse_items,
} from 'approot/activity-builder/__generated__/GetActivitiesSections';

export type ViewProps = Omit<
  ComponentInteractiveResponseSequence,
  '__typename'
>;
export type EditProps = ViewProps;
export type SettingProps = EditProps;
export type InteractiveResponseProperties = GetActivitiesSections_getActivitiesSections_components_ActivitiesInteractiveResponseComponent_properties;
export type InteractiveResponseItem = GetActivitiesSections_getActivitiesSections_components_ActivitiesInteractiveResponseComponent_properties_interactiveResponse_items;

export const DROP_ITEM_SIZE = 104;
export const MIN_LABEL_WIDTH = 104;
export const MAX_SEQUENCE_ITEMS = 8;

export type InteractiveSequenceAttempt = (
  dropItems: DropItem[],
  dragItems: DragItem[]
) => void;
